export enum OwnershipSource {
  Public = 'Public',
  Surveillance = 'Surveillance'
}
